import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { myloreLegal } from './legal-data.js';
import { myloreDocuments } from './documents.js';
export { myloreLegal, myloreDocuments };
const { operator } = myloreLegal;
/**
 * MyLore's legal bundle — a web-only export.
 *
 * Kept out of `BrandConfig` on purpose: the documents are JSX, and the API
 * imports the brand. Anything reachable from `brand` is loaded by the API
 * process, and React has no business being there.
 */
export const legal = {
    indexTitle: 'Юридическая информация и реквизиты',
    indexIntro: () => (_jsxs("p", { children: ["\u0421\u0435\u0440\u0432\u0438\u0441 \u00AB", myloreLegal.serviceName, "\u00BB \u0441\u043E\u0437\u0434\u0430\u0451\u0442 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0435 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u044B\u0435 \u0434\u0435\u0442\u0441\u043A\u0438\u0435 \u043A\u043D\u0438\u0433\u0438 \u043F\u043E \u0437\u0430\u0434\u0430\u043D\u0438\u044E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0441 \u043F\u0440\u0438\u043C\u0435\u043D\u0435\u043D\u0438\u0435\u043C \u0433\u0435\u043D\u0435\u0440\u0430\u0442\u0438\u0432\u043D\u044B\u0445 \u0442\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0438\u0439. \u0417\u0434\u0435\u0441\u044C \u0441\u043E\u0431\u0440\u0430\u043D\u044B \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B \u043E\u0431 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u0445 \u0437\u0430\u043A\u0430\u0437\u0430, \u043E\u043F\u043B\u0430\u0442\u0435, \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0435 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u043E\u0432 \u0438 \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438 \u0433\u043E\u0442\u043E\u0432\u043E\u0439 \u043A\u043D\u0438\u0433\u0438."] })),
    indexOutro: () => (_jsx("p", { children: "\u041E\u0444\u0435\u0440\u0442\u0430 \u0440\u0435\u0433\u0443\u043B\u0438\u0440\u0443\u0435\u0442 \u0434\u043E\u0433\u043E\u0432\u043E\u0440 \u0441 \u0437\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u043E\u043C. \u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0430 \u043E\u043F\u0438\u0441\u044B\u0432\u0430\u0435\u0442 \u043E\u0431\u0449\u0438\u0439 \u043F\u043E\u0440\u044F\u0434\u043E\u043A \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445. \u0421\u043E\u0433\u043B\u0430\u0441\u0438\u044F \u043D\u0430 \u0444\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438, \u0433\u043E\u043B\u043E\u0441 \u0438 \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u044E \u044F\u0432\u043B\u044F\u044E\u0442\u0441\u044F \u0441\u0430\u043C\u043E\u0441\u0442\u043E\u044F\u0442\u0435\u043B\u044C\u043D\u044B\u043C\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u043C\u0438 \u0438 \u043D\u0435 \u0437\u0430\u043C\u0435\u043D\u044F\u044E\u0442 \u0434\u0440\u0443\u0433 \u0434\u0440\u0443\u0433\u0430. \u041F\u0440\u0430\u0432\u0438\u043B\u0430 \u043E\u043F\u043B\u0430\u0442\u044B \u0438 \u0432\u043E\u0437\u0432\u0440\u0430\u0442\u043E\u0432 \u0434\u0435\u0442\u0430\u043B\u0438\u0437\u0438\u0440\u0443\u044E\u0442 \u041E\u0444\u0435\u0440\u0442\u0443." })),
    indexOutroTitle: 'Как устроен комплект',
    quarantineTerm: myloreLegal.quarantineTerm,
    documentVersion: myloreLegal.documentVersion,
    documentVersionId: myloreLegal.documentVersionId,
    requisitesTitle: 'Исполнитель и оператор персональных данных',
    requisites: [
        { label: 'Наименование', value: operator.fullName },
        { label: 'ИНН', value: operator.inn },
        { label: 'ОГРНИП', value: operator.ogrnip },
        { label: 'Сайт', value: myloreLegal.siteUrl, href: myloreLegal.siteUrl },
        { label: 'Электронная почта', value: operator.email, href: `mailto:${operator.email}` },
        { label: 'Телефон', value: operator.phone, href: operator.phoneHref },
        { label: 'Почтовый адрес', value: operator.postalAddress },
    ],
    footerContacts: [
        { icon: 'phone', label: operator.phone, href: operator.phoneHref },
        { icon: 'email', label: operator.email, href: `mailto:${operator.email}` },
        {
            icon: 'telegram',
            label: myloreLegal.socials.telegram.handle,
            href: myloreLegal.socials.telegram.href,
        },
        {
            icon: 'instagram',
            label: myloreLegal.socials.instagram.handle,
            href: myloreLegal.socials.instagram.href,
        },
    ],
    documents: myloreDocuments,
    // Values copied verbatim from the dictionaries, including grammatical cases.
    documentLinks: {
        registerTerms: { ru: 'публичную оферту', en: 'public offer' },
        paywallTerms: { ru: 'условия оферты', en: 'public offer' },
        paywallRefund: { ru: 'оплаты и возвратов', en: 'payment and refund rules' },
        pricingRules: { ru: 'в правилах заказа', en: 'order rules' },
    },
    routes: {
        terms: '/legal/offer',
        privacy: '/legal/privacy',
        payment: '/legal/payment',
        photoConsent: '/legal/photo-consent',
        voiceConsent: '/legal/voice-consent',
        publicationConsent: '/legal/publication-consent',
    },
    footerLinks: [
        { label: 'Тарифы', to: '/pricing' },
        { label: 'Оферта', to: '/legal/offer' },
        { label: 'Персональные данные', to: '/legal/privacy' },
        { label: 'Оплата и возвраты', to: '/legal/payment' },
        { label: 'Cookie', to: '/legal/cookies' },
        { label: 'Реквизиты', to: '/legal' },
    ],
    ui: {
        backHome: '← На главную',
        allDocuments: 'Все документы и реквизиты',
        documentsTitle: 'Документы',
        editionPrefix: 'Редакция от',
        versionPrefix: 'версия',
        footerNavLabel: 'Информация о сервисе',
    },
};
//# sourceMappingURL=legal.js.map